import React from "react";
import PropTypes from "prop-types";
import {APanel, APanelBody} from "@cisco-sbg-ui/magna-react";
import {useSelector} from "react-redux";
import EventsTable from "features/EventsTable/EventsTable";
import {
  selectInvestigationEvents,
  selectInvestigationEventsLoading
} from "store/selectors/investigationSelectors";

const EventsTablePanel = ({
  className,
  openDetectionDrawer,
  openEntityDrawer
}) => {
  const events = useSelector(selectInvestigationEvents);
  const isLoading = useSelector(selectInvestigationEventsLoading);

  return (
    <div className={className}>
      <APanel>
        <APanelBody>
          <EventsTable
            openEntityDrawer={openEntityDrawer}
            openDetectionDrawer={openDetectionDrawer}
            tableData={events}
            eventTotalCount={events?.length}
            isLoading={isLoading}
          />
        </APanelBody>
      </APanel>
    </div>
  );
};

EventsTablePanel.propTypes = {
  className: PropTypes.string
};

export default EventsTablePanel;
